import React from "react";

function AboutChoose({ t }) {
  return (
    <>
      <section className="featuresSection ">
        <div className="container">
          <div className="fisherman-content">
            <h3>{t("why choose us")}</h3>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="feature-box">
                <i className="icon-shipped" />
                <div className="feature-box-content">
                  <h5>Our Vision</h5>
                  <p>
                    To lead the aviation industry through cutting-edge technical
                    innovation and the continuous development of a
                    high-performance workforce. We are committed to delivering
                    excellence in project execution, operations, engineering,
                    consulting, and maintenance management. Our strategic goal
                    is to become the premier aviation solutions provider in
                    Saudi Arabia, setting new benchmarks for efficiency,
                    reliability, and long-term value across the
                    region and beyond.
                  </p>
                </div>
                {/* End .feature-box-content */}
              </div>
              {/* End .feature-box */}
            </div>
            {/* End .col-lg-4 */}
            <div className="col-lg-6">
              <div className="feature-box">
                <i className="icon-us-dollar" />
                <div className="feature-box-content">
                  <h5>Our Mission</h5>
                  <p>
                    We strive for sustained growth and long-term viability,
                    building a reputation for excellence and dependable service.
                    Our commitment to quality and advanced technical
                    capabilities ensures we consistently meet—and exceed—the
                    evolving needs of our customers.
                  </p>
                </div>
                {/* End .feature-box-content */}
              </div>
              {/* End .feature-box */}
            </div>
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>
    </>
  );
}

export default AboutChoose;
